import axios from 'axios'
import {
  Honorific,
  PersonInChargeHonorific
} from 'src/interfaces/api/PostClients'
import { PostInvoicesPayload } from 'src/interfaces/api/PostInvoices'
import { mutate as globalMutate } from 'swr'
import useSWRImmutable from 'swr/immutable'
import { useApiClient } from '../useApiClient'
import { useNewApiClient } from '../useNewApiClient'

// TODO: 以下の２つのconstはAPI自動生成でenumにするなどしたほうがいい
export const honorificTitles: {
  value: Honorific
  label: string
  labelOnPreview: string
}[] = [
  {
    value: 0,
    label: '御中',
    labelOnPreview: '御中'
  },
  {
    value: 1,
    label: '様',
    labelOnPreview: '様'
  },
  {
    value: 2,
    label: '敬称なし',
    labelOnPreview: ''
  }
]

export const honorificPersonInChargeTitles: {
  value: PersonInChargeHonorific
  label: string
  labelOnPreview: string
}[] = [
  {
    value: 1,
    label: '様',
    labelOnPreview: '様'
  },
  { value: 2, label: '敬称なし', labelOnPreview: '' }
]

type Config = {
  page?: number
  count?: number
  /**
   * is_deposited === 'true' ->決済済みの請求書「のみ」取得
   * is_deposited === 'false' ->決済済みの請求書「以外」取得
   * is_deposited === undefined ->すべての請求書取得
   */
  isDeposited?: boolean
  // 検索用
  client?: string
  since?: string
  until?: string
  amountMin?: string
  amountMax?: string
}
export const useInvoices = (config?: Config) => {
  const { apiClient } = useApiClient()
  const { apiClient: newApiClient } = useNewApiClient()
  const {
    page,
    count,
    isDeposited,
    client,
    since,
    until,
    amountMin,
    amountMax
  } = config ?? {}

  const { data: invoices, mutate } = useSWRImmutable(
    `/invoices?${
      isDeposited === undefined
        ? client || since || until || amountMin || amountMax
          ? `client=${client}&since=${since}&until=${until}&amount_min=${amountMin}&amount_max=${amountMax}`
          : ''
        : `is_deposited=${isDeposited ? 'true' : 'false'}`
    }&page=${page ?? 1}${count ? `&count=${count}` : ''}`,
    async () => {
      const res = await apiClient.getInvoices(
        page ?? 1,
        count,
        isDeposited,
        client,
        since,
        until,
        amountMin,
        amountMax
      )
      return res
    }
  )

  const postInvoice = async (payload: PostInvoicesPayload) => {
    const res = await apiClient.postInvoice(payload)
    await mutate()
    return res
  }

  const patchInvoice = async (
    invoiceId: number,
    payload: PostInvoicesPayload
  ) => {
    const res = await apiClient.patchInvoice(invoiceId, payload)
    await globalMutate(`/invoices/${invoiceId}`)
    await mutate()
    return res
  }

  const deleteInvoice = async (invoiceId: number) => {
    await apiClient.deleteInvoice(invoiceId)
    await mutate()
  }

  const postDevTaxesUsers = async () => {
    const res = await apiClient.postDevTaxesUsers()
    await mutate()
    return res
  }

  const postImagesSeal = async (file: File) => {
    const extension = file.type.split('/')[1] as 'jpeg' | 'png' | 'gif'
    const res = await newApiClient.invoice.getInvoicePresignedUrl(
      'seal',
      extension
    )
    const { url, presigned_url } = res
    await axios.put(presigned_url, file, {
      headers: { 'Content-Type': file.type }
    })
    await mutate()

    return url
  }

  const postImagesLogo = async (file: File) => {
    const extension = file.type.split('/')[1] as 'jpeg' | 'png' | 'gif'
    const res = await newApiClient.invoice.getInvoicePresignedUrl(
      'logo',
      extension
    )
    const { url, presigned_url } = res
    await axios.put(presigned_url, file, {
      headers: { 'Content-Type': file.type }
    })
    await mutate()

    return url
  }

  return {
    postImagesLogo,
    postImagesSeal,
    patchInvoice,
    postDevTaxesUsers,
    invoices,
    postInvoice,
    deleteInvoice,
    mutateInvoices: mutate
  }
}
